
export default {
  name: 'Notifications',
  props: {
    value: {
      type: Object,
      default: () => ({
        notifyKpiReportWeekly: false,
        notifyKpiReportMonthly: false
      })
    }
  },
  data() {
    return {
      weeklyReport: this.value.notifyKpiReportWeekly,
      monthlyReport: this.value.notifyKpiReportMonthly
    };
  },
  watch: {
    value: {
      deep: true,
      handler(val) {
        this.weeklyReport = val.notifyKpiReportWeekly;
        this.monthlyReport = val.notifyKpiReportMonthly;
      }
    }
  },
  methods: {
    formatSubtitle(text) {
      if (!text) return '';
      return text.replace(/\.\s+/g, '.<br>');
    },
    onToggle() {
      const payload = {
        notifyKpiReportWeekly: this.weeklyReport,
        notifyKpiReportMonthly: this.monthlyReport
      };

      this.$emit('input', payload);
      this.$emit('change', payload);
    }
  }
};
